<button
  class="ai-btn"
  matTooltip="Create with Lingo AI"
  [class.ai-btn-dark]="_isDarkTheme"
  [class.ai-btn-light]="_isLightTheme"
  [class.ai-btn-paper]="_isPaperTheme"
  (click)="navigateToLingo()"
>
  <div class="ai-btn-bg">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
  </div>
  <span class="ai-btn-content">
    <img class="ai-btn-logo" alt="Lingo AI" [src]="logoSrc" />
    <span class="ai-btn-label">{{ _label }}</span>
  </span>
</button>
